<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons v-slot: start>
            <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
            <ion-title>Charging Status</ion-title>
            </ion-buttons>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <ChargingStatusView />
        </ion-content>
    </div>
</template>
<script>
import ChargingStatusView from "@/components/customer/ChargingStatusView.vue";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonToolbar } from '@ionic/vue';
import { defineComponent } from "vue";

export default defineComponent({
    name:  'chargingStatus',
    components: {
        ChargingStatusView, IonHeader, IonToolbar, IonButtons, IonBackButton, IonContent
    },
    data() {
        return {

        }
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        }
    }
})
</script>
